/**
 * Class for data processing
 */
var safeGetValueReg = /^([^.\[]+)/;
var Data = /** @class */ (function () {
    function Data() {
    }
    /**
     * Mix properties into target object
     * @param target
     * @param source
     */
    Data.extend = function (target) {
        var source = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            source[_i - 1] = arguments[_i];
        }
        return source.reduce(function e(target, source) {
            Object.keys(source).forEach(function (key) {
                var value = source[key];
                if (typeof value !== 'undefined') {
                    if (Data.isPlainObject(value)) {
                        target[key] = e(Data.isPlainObject(target[key]) ? target[key] : {}, value);
                    }
                    else {
                        target[key] = value;
                    }
                }
            });
            return target;
        }, target);
    };
    /**
     * Get value from target object safely, e.g. value.a.b[0].c
     * @param source
     * @param key
     * @param defaults
     */
    Data.safeGetValue = function (source, key, defaults) {
        if (defaults === void 0) { defaults = ''; }
        var newKey = key ? key.replace(safeGetValueReg, function (match) { return "[\"" + match + "\"]"; }) : key;
        var factory = new Function('source', 'defaults', "try { return source" + newKey + " === undefined ? defaults : source" + newKey + " } catch (e) { return defaults }");
        return factory(source, defaults);
    };
    /**
     * Check if the object is plain
     * @param obj
     */
    Data.isPlainObject = function (obj) {
        var proto, Ctor;
        // Detect obvious negatives
        if (!obj || Object.prototype.toString.call(obj) !== '[object Object]') {
            return false;
        }
        proto = Object.getPrototypeOf(obj);
        // Objects with no prototype (e.g., `Object.create( null )`) are plain
        if (!proto) {
            return true;
        }
        // Objects with prototype are plain if they were constructed by a global Object function
        Ctor = Object.prototype.hasOwnProperty.call(proto, 'constructor') && proto.constructor;
        return typeof Ctor === 'function' && Function.prototype.toString.call(Ctor) === Function.prototype.toString.call(Object);
    };
    /**
     * Check object is empty
     * @param obj
     */
    Data.isEmptyObject = function (obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    };
    /**
     * Check formdata
     * @param data
     */
    Data.isFormData = function (data) {
        return (typeof FormData !== 'undefined') && (data instanceof FormData);
    };
    /**
     * Convert a value to a string
     * @param val
     */
    Data.toString = function (val) {
        return val == null
            ? ''
            : typeof val === 'object'
                ? JSON.stringify(val, null, 2)
                : String(val);
    };
    /**
     * Convert a value to a number
     * @param val
     */
    Data.toNumber = function (val) {
        var n = parseFloat(val);
        return isNaN(n) ? val : n;
    };
    /**
     * Convert an Array-like object to a real Array
     * @param list
     * @param start
     */
    Data.toArray = function (list, start) {
        start = start || 0;
        var i = list.length - start;
        var ret = new Array(i);
        while (i--) {
            ret[i] = list[i + start];
        }
        return ret;
    };
    /**
     * Merge an Array of Objects into a single Object.
     */
    Data.toObject = function (arr) {
        var res = {};
        for (var i = 0; i < arr.length; i++) {
            if (arr[i]) {
                Data.extend(res, arr[i]);
            }
        }
        return res;
    };
    /**
     * Convert an Array or object to Object.
     */
    Data.normalizeMap = function (arr) {
        if (Array.isArray(arr)) {
            var map_1 = {};
            arr.forEach(function (value) {
                map_1[value] = value;
            });
            return map_1;
        }
        return arr;
    };
    return Data;
}());
export default Data;
